/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Category of test
 */
export type ChildSubCategoryDtoCategoryOfTest =
  (typeof ChildSubCategoryDtoCategoryOfTest)[keyof typeof ChildSubCategoryDtoCategoryOfTest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChildSubCategoryDtoCategoryOfTest = {
  direct: 'direct',
  indirect: 'indirect',
  observation: 'observation',
  others: 'others',
} as const;
